import logoSignature from "@/assets/logo-signature.png";

interface SignaturePreviewProps {
  name: string;
  title: string;
  phone: string;
  email: string;
  calUrl: string;
  photoPreview: string;
}

const colors = {
  bg: "#000000",
  text: "#ffffff",
  textMuted: "#a0a0a0",
  accent: "#10B981",
  buttonText: "#ffffff",
};

const SignaturePreview = ({ name, title, phone, email, calUrl, photoPreview }: SignaturePreviewProps) => {
  const phoneHref = `tel:+1${phone.replace(/\D/g, "")}`;
  const mailHref = `mailto:${email}`;

  return (
    <div className="p-6 rounded-lg border mb-6" style={{ backgroundColor: '#1a1a1a' }}>
      <h2 className="text-lg font-semibold mb-4 text-foreground">Prévisualisation</h2>
      <div style={{ backgroundColor: colors.bg, padding: '18px', borderRadius: '6px', display: 'inline-block' }}>
        <table cellPadding="0" cellSpacing="0" style={{ fontFamily: 'Arial, sans-serif', fontSize: '13px', lineHeight: 1.5 }}>
          <tbody>
            <tr>
              <td style={{ verticalAlign: 'top', paddingRight: '20px', width: '100px' }}>
                {photoPreview ? (
                  <img src={photoPreview} alt={name} width="100" height="100" style={{ borderRadius: '6px', objectFit: 'cover', display: 'block', marginBottom: '10px' }} />
                ) : (
                  <div style={{ width: '100px', height: '100px', borderRadius: '6px', backgroundColor: '#333', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '10px', color: '#666', fontSize: '11px', textAlign: 'center' }}>
                    Photo
                  </div>
                )}
                <img src={logoSignature} alt="Agence 8020" width="50" style={{ display: 'block', margin: '0 auto' }} />
              </td>
              <td style={{ verticalAlign: 'top' }}>
                <table cellPadding="0" cellSpacing="0">
                  <tbody>
                    <tr>
                      <td>
                        <strong style={{ fontSize: '18px', color: colors.text, fontWeight: 'bold' }}>{name || "Nom complet"}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ paddingTop: '2px', paddingBottom: '10px' }}>
                        <span style={{ color: colors.textMuted, fontSize: '13px' }}>{title || "Titre"}</span><br />
                        <span style={{ color: colors.textMuted, fontSize: '13px', fontWeight: 600 }}>Agence 8020</span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ paddingBottom: '12px' }}>
                        <div style={{ width: '140px', height: '2px', backgroundColor: colors.accent }}></div>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ paddingBottom: '5px' }}>
                        <table cellPadding="0" cellSpacing="0">
                          <tbody>
                            <tr>
                              <td style={{ paddingRight: '8px', verticalAlign: 'middle' }}>
                                <span style={{ color: colors.accent, fontSize: '14px' }}>📞</span>
                              </td>
                              <td>
                                <a href={phoneHref} style={{ color: colors.accent, textDecoration: 'underline', fontSize: '13px' }}>{phone || "000-000-0000"}</a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ paddingBottom: '5px' }}>
                        <table cellPadding="0" cellSpacing="0">
                          <tbody>
                            <tr>
                              <td style={{ paddingRight: '8px', verticalAlign: 'middle' }}>
                                <span style={{ color: colors.accent, fontSize: '14px' }}>✉️</span>
                              </td>
                              <td>
                                <a href={mailHref} style={{ color: colors.accent, textDecoration: 'underline', fontSize: '13px' }}>{email || "courriel@agence8020.com"}</a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <table cellPadding="0" cellSpacing="0">
                          <tbody>
                            <tr>
                              <td style={{ paddingRight: '8px', verticalAlign: 'middle' }}>
                                <span style={{ color: colors.accent, fontSize: '14px' }}>🌐</span>
                              </td>
                              <td>
                                <a href="https://agence8020.com" style={{ color: colors.accent, textDecoration: 'underline', fontSize: '13px' }}>agence8020.com</a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td colSpan={2} style={{ paddingTop: '16px', textAlign: 'center' }}>
                <a
                  href={calUrl || "#"}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-block',
                    backgroundColor: colors.accent,
                    color: colors.buttonText,
                    textDecoration: 'none',
                    fontSize: '13px',
                    fontWeight: 600,
                    padding: '10px 28px',
                    borderRadius: '6px'
                  }}
                >
                  Prendre rendez-vous
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SignaturePreview;
